module.exports = __webpack_public_path__ + "img/noResult.a9a18ae2.svg";